(ns hypnos.consumer.app
  "The consumer application."
  (:require [hypnos.consumer.panels.consult :as consult]
            [hypnos.consumer.panels.error :as error]
            [hypnos.consumer.panels.footer :as footer]
            [hypnos.consumer.panels.home :as home]
            [hypnos.consumer.panels.nav-bar :as nav-bar]
            [hypnos.consumer.panels.portrait :as portrait]
            [hypnos.consumer.subs]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- panels
  [panel]
  (case (:name panel)
    :error-panel    [error/panel]
    :home-panel     [home/panel]
    :consult-panel  [consult/panel (:params panel)]
    :portrait-panel [portrait/panel (:params panel)]
    [:div]))

(defn- container []
  (let [panel (rf/subscribe [:consumer/active-panel])]
    [:div
     [nav-bar/panel]
     [:section.is-main-section
      [panels @panel]]
     [footer/panel]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; API

(def app
  (reagent/adapt-react-class
   (reagent/reactify-component container)))
